import { HugeiconsIcon } from "@hugeicons/react";
import {
  CreditCardAddIcon,
  MoneyExchange01Icon,
} from "@hugeicons-pro/core-stroke-rounded";
import type { TFunction } from "i18next";
import CardRequestType from "enums/CardRequestType";
import { cardRequestTypeLabel } from "utils/cards/cardRequestTypeLabel";
import { Inline } from "components/layout/reusableLayouts";

export const renderCardTypeIcon = (type: string | undefined, t: TFunction) => {
  if (!type) return <>-</>;

  const icon =
    type === CardRequestType.NEW ? (
      <HugeiconsIcon
        icon={CreditCardAddIcon}
        color="var(--color-status-success-text)"
      />
    ) : type === CardRequestType.POLICY_UPDATE ? (
      <HugeiconsIcon
        icon={MoneyExchange01Icon}
        color="var(--color-text-brand)"
      />
    ) : null;

  return (
    <Inline gap="var(--space-2)" wrap={false}>
      {icon}
      {cardRequestTypeLabel(type, t)}
    </Inline>
  );
};
